import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'About', path: '/about' },
  { label: 'Locations', path: '/locations' },
];

const PHONE = '346-363-8363';
const PHONE_HREF = 'tel:3463638363';
const LOGO = 'https://onecallhandymanhouston.com/insert-files/company-logo.png';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      <header className="fixed top-0 left-0 w-full z-50 bg-white border-b border-gray-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between gap-6">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <img
              src={LOGO}
              alt="One Call Handyman Service"
              className="h-12 w-auto object-contain"
              onError={(e) => {
                const img = e.target as HTMLImageElement;
                img.style.display = 'none';
                const span = document.createElement('span');
                span.className = 'font-serif text-gray-900 text-lg font-semibold';
                span.innerHTML = 'One Call <span style="color:#BF9448">Handyman</span>';
                img.parentElement?.appendChild(span);
              }}
            />
          </Link>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-7">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-xs font-sans font-medium tracking-widest uppercase transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-[#BF9448]'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-5">
            <a
              href={PHONE_HREF}
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900 text-sm font-sans transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-[#BF9448]"></i>
              </span>
              {PHONE}
            </a>
            <a
              href="#quote"
              className="bg-[#BF9448] hover:bg-[#D4AB5E] text-white text-xs font-sans font-semibold px-5 py-3 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer tracking-wider uppercase"
            >
              Free Quote
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            className="lg:hidden text-gray-700 p-2 cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
          </button>
        </div>

        {/* Mobile dropdown */}
        {menuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-100">
            <nav className="px-6 py-5 flex flex-col gap-1">
              {NAV_LINKS.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-sans tracking-wider uppercase py-3 border-b border-gray-100 whitespace-nowrap cursor-pointer ${
                    location.pathname === link.path ? 'text-[#BF9448]' : 'text-gray-600'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href={PHONE_HREF}
                className="flex items-center gap-2 text-gray-600 text-sm font-sans py-3 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill text-[#BF9448]"></i>
                {PHONE}
              </a>
              <a
                href="#quote"
                className="mt-2 bg-[#BF9448] text-white text-sm font-sans font-semibold px-5 py-3 rounded-md text-center cursor-pointer whitespace-nowrap"
              >
                Get Free Quote
              </a>
            </nav>
          </div>
        )}
      </header>

      {/* Mobile sticky bottom bar */}
      <div className="lg:hidden fixed bottom-0 left-0 w-full z-50 flex border-t border-gray-100">
        <a
          href={PHONE_HREF}
          className="flex-1 flex items-center justify-center gap-2 py-4 bg-white text-gray-800 text-sm font-sans cursor-pointer hover:bg-gray-50 transition-colors duration-200 whitespace-nowrap"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-phone-fill text-[#BF9448] text-base"></i>
          </span>
          Call Now
        </a>
        <a
          href="#quote"
          className="flex-1 flex items-center justify-center gap-2 py-4 bg-[#BF9448] text-white text-sm font-sans font-semibold cursor-pointer hover:bg-[#D4AB5E] transition-colors duration-200 whitespace-nowrap"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-file-list-3-line text-base"></i>
          </span>
          Free Quote
        </a>
      </div>
    </>
  );
}
